module.exports = __webpack_public_path__ + "img/lark.3878c8bd.svg";